import { Group } from '../models';
import { GroupView } from '../views/GroupView';

export class AdminGroupViewCreator {
  constructor() {}

  public CreateView(group: Group): GroupView {
    return {
      id: group.id,
      pledge: group.pledge,
      startDate: group.startDate,
      endDate: group.endDate || null,
      finalizedAt: group.finalizedAt || null,
      finalizedByUserName: group.finalizedByUserName || null,
      name: group.name,
      cohortUserId: group.cohortUserId,
      userCount: group.userCount,
      groupLogo: group.groupLogo,
      shortDescription: group.shortDescription,
      channel: group.channel,
      inPersonCelebration: group.inPersonCelebration,
      currentWeekNumberIndexZero: group.currentWeekNumberIndexZero,
      finalized: group.finalized,
      createdAt: group.createdAt || null,
      createdBy: group.createdBy || null,
      participants: group.cohortUsers?.map((u) => ({
        id: u.id,
        name: u.user.name,
        email: u.user.email,
        avatarUrl: u.user.avatarUrl,
        role: u.role,
        isNew: false,
        CohortUser: u,
      })),
    } as GroupView;
  }
}
